import { Component } from 'react';

export class CloseCircleSVG extends Component<{ className?: string }> {
    render() {
        const { className } = this.props;

        return (
            <svg
                className={className}
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.28462 18.5692C14.4124 18.5692 18.5692 14.4124 18.5692 9.28462C18.5692 4.15686 14.4124 0 9.28462 0C4.15686 0 0 4.15686 0 9.28462C0 14.4124 4.15686 18.5692 9.28462 18.5692Z"
                    fill="#919CA6"
                />
                <path
                    d="M12.3131 6.58371C12.4068 6.67746 12.4537 6.79129 12.4537 6.92522C12.4537 7.05915 12.4068 7.17299 12.3131 7.26674L11.6301 7.94978C11.5363 8.04353 11.4225 8.0904 11.2885 8.0904C11.1546 8.0904 11.0408 8.04353 10.947 7.94978L9.47046 6.47321L7.99389 7.94978C7.90014 8.04353 7.78631 8.0904 7.65238 8.0904C7.51845 8.0904 7.40461 8.04353 7.31086 7.94978L6.62782 7.26674C6.53407 7.17299 6.4872 7.05915 6.4872 6.92522C6.4872 6.79129 6.53407 6.67746 6.62782 6.58371L8.10439 5.10714L6.62782 3.63058C6.53407 3.53683 6.4872 3.42299 6.4872 3.28906C6.4872 3.15513 6.53407 3.04129 6.62782 2.94754L7.31086 2.26451C7.40461 2.17076 7.51845 2.12388 7.65238 2.12388C7.78631 2.12388 7.90014 2.17076 7.99389 2.26451L9.47046 3.74107L10.947 2.26451C11.0408 2.17076 11.1546 2.12388 11.2885 2.12388C11.4225 2.12388 11.5363 2.17076 11.6301 2.26451L12.3131 2.94754C12.4068 3.04129 12.4537 3.15513 12.4537 3.28906C12.4537 3.42299 12.4068 3.53683 12.3131 3.63058L10.8365 5.10714L12.3131 6.58371Z"
                    transform="translate(0 4.4541)"
                    fill="white"
                />
            </svg>
        );
    }
}
